export default [
    {
        text: "I had an incredible experience with RentACar. The car was clean, well-maintained, and the customer service was top-notch. I'll definitely be renting from them again!",
        name: "Sloboda Micalovic",
        city: "Bijeljina",
        img: "testimonial1.jpg"
    },
    {
        text: "Thank you, RentACar, for making my trip hassle-free. The car was delivered on time, and the whole process was smooth and efficient. Highly recommended!",
        name: "Luka Raco",
        city: "Zagreb",
        img: "testimonial2.jpg"
    },
    {
        text: "I've rented from various car companies before, but RentACar exceeded my expectations. The staff was friendly, and the rates were reasonable. I had a great journey!",
        name: "Dragan Kojic",
        city: "Belgrade",
        img: "testimonial3.jpg"
    },
    {
        text: "RentACar made our vacation memorable. The spacious and comfortable car made our road trip enjoyable, and the team was responsive to all our queries.",
        name: "Dragan Jovanovic",
        city: "Novi Sad",
        img: "testimonial4.jpg"
    },
    {
        text: "I'm a frequent traveler, and I always choose RentACar. They consistently deliver excellent service and have a diverse fleet of cars to choose from.",
        name: "Nemanja Stevanovic",
        city: "Belgrade",
        img: "testimonial5.jpg"
    },
    {
        text: "The convenience of renting from RentACar is unparalleled. Their online booking process is straightforward, and the pickup/drop-off was a breeze.",
        name: "Josipa Lisac",
        city: "Zagreb",
        img: "testimonial6.jpg"
    },
    {
        text: "A big shout-out to RentACar for their outstanding service. They went the extra mile to accommodate my special requests, making my trip stress-free.",
        name: "Vojin Cetkovic",
        city: "Belgrade",
        img: "testimonial7.jpg"
    },
    {
        text: "I rented a car for a weekend getaway, and it was a fantastic experience. The car was in pristine condition, and the whole process was quick and efficient.",
        name: "Drasko Stanivukovic",
        city: "Banja Luka",
        img: "testimonial8.jpg"
    },
    {
        text: "I highly recommend RentACar to anyone in need of a reliable rental service. Their attention to detail and customer care are exceptional.",
        name: "Ivana Nikolic",
        city: "Ljubljana",
        img: "testimonial9.jpg"
    }
]